import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TrackingPage from './pages/TrackingPage';
import HomePage from './pages/HomePage';
import './App.css';

function NotFoundPage() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      overflow: 'hidden',
      background: '#fff',
      fontFamily: 'Lato, sans-serif',
      padding: '80px 20px'
    }}>
      <div style={{ textAlign: 'center', maxWidth: '500px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#333', marginBottom: '12px' }}>
          Whoops!
        </h1>
        <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
          We can't seem to find what you're looking for.
        </p>
        <p style={{ fontSize: '14px', color: '#999', marginTop: '16px', lineHeight: '1.6' }}>
          You can find the tracking link in your order summary, Order Confirmation Email, or contact us.
        </p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/track/:trackingNumber" element={<TrackingPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
